import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLaptop, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import DynamicZone from '../../helpers/dynamicZone'
import { Layout } from '../../components'
import './career.scss'

const Career = ({ pageContext }) => {
  // pageContext - Elementos pasados como parametros
  // data - Información obtenida de la query
  
  const { 
    careerId, 
    careerData,
    homeData,
    navbar,
    footerData
  } = pageContext

  const { body, pageMetadata, scripts } = careerData

  // Creando el componente Admision Button y agregandolo al body
  const admisionButton = {
    id: 1,
    __component: "admision-button",
    visible: true,
    career: careerData
  }

  if (body.length === 0) {
    body.push(admisionButton);
  } else {
    const exists = body.some(item => item.__component === "admision-button");
    if (!exists) {
      body.splice(1, 0, admisionButton);
    }
  }

  return (
    <Layout
      key={`career-${careerId}`}
      homeData={homeData}
      screenData={navbar} 
      scriptSelect={scripts}
      pageMetadata={pageMetadata}
      footerData={footerData}
    >
      {/* Career Places Label */}
      <div className='career-location-container'>
        {careerData.career_places && 
          careerData.career_places
            ?.sort((a, b) => a.title.localeCompare(b.title))
            .map((places) => {
              return (
                <div className='d-flex align-items-center justify-content-start'>
                  <FontAwesomeIcon
                    icon={places.title === "A Distancia" ? faLaptop : faLocationDot}
                    className="me-2"
                    color={places.colorHex}
                  />
                  <h5 className='font-italic m-0' style={{color: places.colorHex}}>{places.title}</h5>
                </div>
              )
            })
          }
      </div>

      <DynamicZone components={body} />
    </Layout>
  )
}

Career.propTypes = {
  pageContext: PropTypes.object.isRequired,
}

export default Career